"use client"

import React, { useContext, useEffect, useState } from "react"
import Signup from "@/components/Signup/Signup"

//UI Context
import { ModalContext } from "@/contexts/ModalProvider"
//Modal Container Component
import Modal from "../ModalForm/Modal"
import styles from "./SignupForm.module.scss"

const SIGNUP_MODAL_HASH = "signup"

export default function SignupForm({
  isOnline,
  texts,
  eventSlug = null,
  bottomText,
  form_id,
}) {
  const { openModal, setOpenModal } = useContext(ModalContext)
  const [hasMounted, setHasMounted] = useState(false)

  const toggleHash = () => {
    // location.replace for trigger hashchange
    if (
      (openModal && !window.location.hash) ||
      (!openModal && window.location.hash === `#${SIGNUP_MODAL_HASH}`)
    ) {
      window.location.replace(openModal ? `#${SIGNUP_MODAL_HASH}` : "#")
    }
  }

  function escClose(e) {
    if (openModal && e.code === "Escape") {
      setOpenModal(false)
    }
  }

  const handleHash = () => {
    if (!window.location.hash) {
      return
    }
    const hash = window.location.hash.slice(1)

    if (hash === SIGNUP_MODAL_HASH) {
      setOpenModal(true)
    }
  }
  useEffect(() => {
    if (hasMounted) {
      toggleHash()
    } else {
      setHasMounted(true) // Отмечаем, что компонент уже отрисовался
    }
  }, [openModal])

  useEffect(() => {
    handleHash()
    document.addEventListener("keydown", escClose)

    return () => {
      window.removeEventListener("keydown", escClose)
    }
  }, [])

  return (
    <div className={styles.SignupForm}>
      <Modal>
        {/*Custom Modal Component*/}
        {openModal && (
          <div className={styles.SignupForm__form}>
            {/* <div
            className={styles.SignupForm__note}
            dangerouslySetInnerHTML={{ __html: texts.cancelled }}
          ></div> */}
            <Signup
              className={styles.SignupForm__signup}
              isOnline={isOnline}
              withRadio
              texts={texts}
              eventSlug={eventSlug}
              bottomText={bottomText}
              form_id={form_id}
            />
            <button
              aria-label="Close"
              type="button"
              className={styles.SignupForm__close}
              onClick={() => {
                setOpenModal(false)
                // toggleHash()
              }}
            ></button>
          </div>
        )}
      </Modal>
    </div>
  )
}
